import { tap } from 'rxjs';
import { SessionService } from '@shared/services/session.service';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionService = inject(SessionService);

  return next(req).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        if (error.status === 401) {
          sessionService.expireSessionAndLogout(true);
        }
      },
    }),
  );
};
